module.exports = __webpack_public_path__ + "img/jb-1.38a500f3.png";